import { useCallback, useEffect } from 'react';
import { useTrtcStore } from '@src/store/trtc';
import { IsTrtcUser } from '@src/utils/api/trtc-api';
import { getCookie } from '@src/utils/cookies/index';

export const IS_NEW_USER_LASTEST_TIME = getCookie('saas_ownerUin') + 'isNewUserLastestTime';

export function useIsTRTCUser(stopFlag: boolean = false) {
  const setIsTRTCUser = useTrtcStore(state => state.setIsTRTCUser);

  const getIsTrtcUser = useCallback(async () => {
    try {
      const data: { IsTrtcUser: number } = await IsTrtcUser();
      const isTrtcUser = Number(data.IsTrtcUser) !== 0;
      setIsTRTCUser(isTrtcUser);
      if (!isTrtcUser) {
        localStorage.setItem(IS_NEW_USER_LASTEST_TIME, String(new Date().valueOf()));
      }
      return isTrtcUser;
    } catch (e) {
      setIsTRTCUser(false);
    }
  }, []);

  useEffect(() => {
    if (stopFlag) return;
    getIsTrtcUser();
  }, [getIsTrtcUser, stopFlag]);
}
